import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/de/community/themen')({
  component: Outlet,
})
